document.addEventListener("DOMContentLoaded", function () {
  // Target the blog content container for Hurray’s Girl Beer articles
  const blogContent = document.querySelector(".article-template__content.rte");
  if (!blogContent) return;

  // Replace all occurrences of the shortcode [collection-carousel="collection-handle"]
  blogContent.innerHTML = blogContent.innerHTML.replace(/\[collection-carousel="(.*?)"\](<br\s*\/?>)?/g, function(match, collectionHandle) {
    // Generate a unique ID for this carousel instance
    const uniqueID = "hurray-carousel-" + Math.random().toString(36).substr(2, 9);
    // Return the carousel markup with the collection handle stored as a data attribute
    return `
      <section class="hurray-slider-wrapper">
        <div class="hurray-slider-carousel">
          <div class="swiper-container">
            <div class="swiper-wrapper product-carousel" id="${uniqueID}" data-collection-handle="${collectionHandle}"></div>
          </div>
        </div>
      </section>
    `;
  });

  // Process each generated carousel container
  const carouselContainers = blogContent.querySelectorAll(".product-carousel[data-collection-handle]");
  carouselContainers.forEach((container) => {
    const collectionHandle = container.getAttribute("data-collection-handle");
    const apiURL = `/collections/${collectionHandle}/products.json?limit=10`;

    fetch(apiURL)
      .then(response => response.json())
      .then(data => {
        let slides = "";
        data.products.forEach(product => {
          const productImage = product.images.length > 0 ? product.images[0].src : "https://via.placeholder.com/600";
          const productTitle = product.title || "Unknown Product";
          const productPrice = product.variants[0].price ? `$${product.variants[0].price}` : "Price Not Available";
          const productURL = `/products/${product.handle}`;
          slides += `
            <div class="swiper-slide product-item" style="background-image: url('${productImage}');">
                <div class="product-name">${productTitle}</div>
                <div class="product-prices">${productPrice}</div>
                <a href="${productURL}" class="purchase-btn">BUY NOW</a>
            </div>
          `;
        });
        container.innerHTML = slides;

        // Initialize Swiper for this carousel instance
        setTimeout(() => {
          let swiper = new Swiper(container.closest('.swiper-container'), {
            slidesPerView: 'auto',
            spaceBetween: 10,
            freeMode: true,
            loop: false,
            navigation: false,
            pagination: false
          });
          swiper.update();
        }, 500);
      })
      .catch(error => console.log("Error fetching collection products:", error));
  });
});
